import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-daisyui';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface ActionConfirmationModalProps {
  modalID: string;
  isOpen: boolean;
  onClose: () => void;
  onAction: () => void;
  selectedData?: Set<any>; // optional
  title?: string;  // optional
  content?: React.ReactNode;  // optional
  showInfoAlert?: boolean; // optional
}

const ActionConfirmationModal: React.FC<ActionConfirmationModalProps> = ({
  modalID,
  isOpen,
  onClose,
  onAction,
  selectedData,
  title = 'Confirm Modal', // Default value for title
  content = (<><p>Please confirm the action.</p></>), // Default value for content
  showInfoAlert
}) => {
  const [loading, setLoading] = useState(false);

  // Wraps the action and resolves if its async or if its sync
  const onActionWrapper = (onAction: () => void) =>{
    setLoading(true);
    Promise.resolve(onAction()).catch((e)=>{
      toast.error(`Unknown error completing the action. ${e}`)
    })
  }

  useEffect(() => {
    isOpen && setLoading(false);
  }, [isOpen]);

  return (
    <Modal open={isOpen}>
      <Modal.Header className="font-bold">{title}</Modal.Header>

      <Modal.Body>
        {content}
        {loading && showInfoAlert && <p className='my-3'>
          <div role="alert" className="alert alert-info">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              className="h-6 w-6 shrink-0 stroke-current">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <span>Processing your report. Please wait.</span>
          </div></p>}
      </Modal.Body>

      <Modal.Actions>
        <Button id={`${modalID}_CancelButton`} type="button" disabled={loading} onClick={onClose}>
          Cancel
        </Button>
        <Button
          id={`${modalID}_ConfirmButton`}
          type="button"
          color="primary"
          className={loading ? 'pointer-events-none' : ''}
          onClick={loading ? undefined : () => onActionWrapper(onAction)}
        >
          {loading ? (
            'Loading...'
          ) : (
            'Confirm'
          )}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ActionConfirmationModal;
